import { useState } from "react";
import Icon from "components/Elements/Icon/Icon";
import Image from "components/Elements/Image/Image";
import Tooltip from "components/Elements/Tooltip/Tooltip";
import "./RadioElement.scss";

const RadioElement = (props) => {
  const {
    fieldToCheck,
    setState,
    state,
    textRadioObject,
    tooltipRadio,
    specificClass,
    dislabeText,
    tooltipOnHover,
  } = props;
  const [hovered, setHovered] = useState(false);

  return (
    <div
      className={`radio-element-container ${
        specificClass ? specificClass : ""
      }`}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <Image
        className="input-checkbox"
        onClick={(e) => {
          setState(fieldToCheck);
        }}
        name={state === fieldToCheck ? "radio-checked" : "radio-unchecked"}
        ext="svg"
      />
      <span className={`input-label ${dislabeText && "disabled"}`}>
        {textRadioObject}
      </span>{" "}
      {tooltipRadio && (tooltipOnHover ? hovered : true) && (
        <Tooltip id={tooltipRadio} tooltipTextKey={tooltipRadio} top>
          <Icon name="question-circle" iconClass="tooltip-question" />
        </Tooltip>
      )}
    </div>
  );
};

export default RadioElement;
